import { dehydrate, QueryClient } from '@tanstack/react-query';
import type { GetServerSideProps } from 'next';
import dynamic from 'next/dynamic';

import { ARTICLE_BY_GROUP } from 'src/constants/services';
import { diseaseListQueryKey } from 'src/hooks/Disease/useDisease';
import wrapper from 'src/redux';
import { actionGetFooterMenu, actionGetMenu } from 'src/redux/actions';
import { fetchApiV3Publishing } from 'src/utils/fetch-api';
import { getLayoutMobileServer } from 'src/utils/layout-mobile';

const HeadC = dynamic(() => import('src/components/Head'));
const InfoPenyakitLayout = dynamic(() => import('src/components/Layout/InfoPenyakit'));
const SearchPenyakit = dynamic(() => import('src/containers/InfoPenyakit/Search'));
const TabPenyakit = dynamic(() => import('src/containers/InfoPenyakit/Tab'));

const InfoPenyakitPage = () => {
	return (
		<>
			<HeadC
				title="Informasi Direktori Penyakit"
				description={
					'Ketahui informasi mengenai direktori penyakit terbaru dan terlengkap. ' +
					'Mulai dari pengertian, penyebab, gejala dan pengobatan hanya di KlikDokter.'
				}
			/>

			<InfoPenyakitLayout
				header={<SearchPenyakit />}
				adSource="penyakit"
				adTarget={[['channel', ['penyakit']]]}
			>
				<TabPenyakit />
			</InfoPenyakitLayout>
		</>
	);
};

export const getServerSideProps: GetServerSideProps = wrapper.getServerSideProps(
	(store) => async (ctx) => {
		const queryClient = new QueryClient();

		await store.dispatch(actionGetMenu());
		await store.dispatch(actionGetFooterMenu());

		const page = Number(ctx?.query?.page) || 1;
		const alphabet = ctx?.query?.alphabet || 'a';

		await queryClient.prefetchQuery({
			queryKey: [diseaseListQueryKey, page, alphabet],
			queryFn: () =>
				fetchApiV3Publishing({
					url: `${ARTICLE_BY_GROUP.service}/all`,
					options: { method: 'GET' },
					payload: {
						start_with: alphabet,
						type: ARTICLE_BY_GROUP.model.penyakit,
						order: 'asc',
						order_by: 'slug',
						page,
						per_page: 50,
					},
				}),
		});

		return {
			props: {
				card: true,
				dehydratedState: dehydrate(queryClient),
				isWhiteBackground: true,
				pageHeaderContent: {
					title: 'Penyakit',
					breadcrumbs: [{ label: 'Penyakit' }],
				},
				layoutMobile: getLayoutMobileServer(ctx),
			},
		};
	},
);

export default InfoPenyakitPage;
